import { enUS, zhTW } from '@mui/material/locale';
import { createTheme } from '@mui/material/styles';

import colors from './colors';
import componentStyleOverrides from './customize';
import themePalette from './palette';
import themeTypography from './typography';

const getThemeSource = (customization) => {
  const locale = navigator.language;
  const themeOption = { ...colors, customization };

  const themeOptions = {
    direction: 'ltr',
    palette: themePalette(themeOption),
    mixins: {
      toolbar: {
        minHeight: '48px',
        padding: '16px',
        '@media (min-width: 600px)': {
          minHeight: '48px',
        },
      },
    },
    typography: themeTypography(themeOption),
    components: componentStyleOverrides(themeOption),
    zIndex: {
      mobileStepper: 100,
      fab: 105,
      speedDial: 105,
      appBar: 110,
      drawer: 120,
      modal: 130,
      snackbar: 140,
      tooltip: 150,
    },
  };

  return createTheme(themeOptions, locale === 'zh-tw' ? zhTW : enUS);
};

export default getThemeSource;
